import { render } from "./Footie.vue?vue&type=template&id=b716dfa0"
const script = {}

import "./Footie.vue?vue&type=style&index=0&id=b716dfa0&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__